/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  var numericPostalCountries = [
    'austria',
    'belgium',
    'danmark',
    'denmark',
    'deutschland',
    'finland',
    'france',
    'germany',
    'italy',
    'norge',
    'norway',
    'poland',
    'portugal',
    'spain',
    'sverige',
    'sweden',
    'switzerland',
    'united states',
    'united states of america'
  ];

  function getLiveRegion() {
    var region = document.getElementById('lptp-cart-live-region');

    if (region) {
      return region;
    }

    region = document.createElement('div');
    region.id = 'lptp-cart-live-region';
    region.className = 'visually-hidden';
    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    document.body.appendChild(region);

    return region;
  }

  function announce(message) {
    if (!message) {
      return;
    }

    getLiveRegion().textContent = '';

    window.setTimeout(function () {
      getLiveRegion().textContent = message;
    }, 60);
  }

  function getSelectedCountryValue(select) {
    if (!select) {
      return '';
    }

    var selectedOption = select.options && select.options[select.selectedIndex];

    return [
      select.value,
      selectedOption ? selectedOption.text : '',
      select.getAttribute('data-default')
    ].join(' ').toLowerCase();
  }

  function usesNumericPostalCode(countryValue) {
    return numericPostalCountries.some(function (country) {
      return countryValue.indexOf(country) !== -1;
    });
  }

  function syncPostalCodeInputs() {
    var zipInputs = document.querySelectorAll('#shipping-estimator-zip');

    zipInputs.forEach(function (input) {
      var estimator = input.closest('.shipping-estimator') || document;
      var countrySelect = estimator.querySelector('#shipping-estimator-country');
      var countryValue = getSelectedCountryValue(countrySelect);

      input.setAttribute('autocomplete', 'postal-code');
      input.setAttribute('autocapitalize', 'characters');
      input.setAttribute('enterkeyhint', 'done');
      input.setAttribute('inputmode', usesNumericPostalCode(countryValue) ? 'numeric' : 'text');
    });
  }

  function markSubmittingButton(event) {
    var button = event.target.closest('buy-button button[type="submit"]');

    if (!button) {
      return;
    }

    button.classList.add('is-submitting');
    button.setAttribute('aria-busy', 'true');
  }

  function markAddedState(event) {
    var button = event.detail && event.detail.button;

    if (!button || event.detail.productAdded === false) {
      if (button) {
        button.classList.remove('is-submitting');
        button.removeAttribute('aria-busy');
      }

      return;
    }

    var originalText = button.getAttribute('data-original-text') || button.textContent;
    button.setAttribute('data-original-text', originalText);
    button.classList.remove('is-submitting');
    button.removeAttribute('aria-busy');
    button.classList.add('is-added');
    button.textContent = window.languages && window.languages.productAddedShort ? window.languages.productAddedShort : originalText;

    if (button._lptpAddedTimer) {
      window.clearTimeout(button._lptpAddedTimer);
    }

    announce(window.languages && window.languages.productAdded ? window.languages.productAdded : button.textContent);

    button._lptpAddedTimer = window.setTimeout(function () {
      button.classList.remove('is-added');
      button.textContent = originalText;
      button._lptpAddedTimer = null;
    }, 2200);
  }

  document.addEventListener('click', markSubmittingButton, true);
  document.addEventListener('product:added', markAddedState);
  document.addEventListener('DOMContentLoaded', syncPostalCodeInputs);
  document.addEventListener('change', function (event) {
    if (event.target && event.target.id === 'shipping-estimator-country') {
      syncPostalCodeInputs();
    }
  });
  document.documentElement.addEventListener('cart:refresh', syncPostalCodeInputs);
  document.documentElement.addEventListener('cart:rerendered', syncPostalCodeInputs);
})();
